import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Search, User, Shield, LogOut } from "lucide-react";
import Logo from "../../Components/Logo/Logo";
import Logout from "../Log/Logout";
import ImageProfil from "../Profil/ImageProfil";
import Notification from "../Notification/notification";
import SearchPalette from "./SearchPalette";

const isMac =
  typeof navigator !== "undefined" && /Mac/i.test(navigator.platform);

const Nav = ({ socket }) => {
  const [paletteOpen, setPaletteOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const profilRef = useRef(null);

  const userData = useSelector((state) => state.userReducer);
  const initials =
    (userData.firstname?.[0] || "") + (userData.name?.[0] || "");

  useEffect(() => {
    socket?.emit("newUser", userData.name + " " + userData.firstname);
  }, [socket, userData.name, userData.firstname]);

  // Raccourci global ⌘K / Ctrl+K
  useEffect(() => {
    const onKeyDown = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setPaletteOpen((open) => !open);
      }
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, []);

  // Fermeture du menu profil : clic extérieur ou Échap
  useEffect(() => {
    if (!menuOpen) return;
    const onClickOutside = (e) => {
      if (profilRef.current && !profilRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    const onEscape = (e) => {
      if (e.key === "Escape") setMenuOpen(false);
    };
    document.addEventListener("mousedown", onClickOutside);
    document.addEventListener("keydown", onEscape);
    return () => {
      document.removeEventListener("mousedown", onClickOutside);
      document.removeEventListener("keydown", onEscape);
    };
  }, [menuOpen]);

  return (
    <header className="Navheader">
      <div className="logo">
        <Logo />
      </div>

      <div className="search-zone">
        <button
          type="button"
          className="search-trigger"
          onClick={() => setPaletteOpen(true)}
        >
          <Search size={15} />
          <span className="search-trigger-label">Rechercher</span>
          <kbd>{isMac ? "⌘K" : "Ctrl K"}</kbd>
        </button>
      </div>

      <div className="action">
        <Notification user={userData.id} socket={socket} />
        <p className="welcome">
          Bienvenue <span>{userData.firstname}</span> 👋
        </p>
        <div className="profil-wrapper" ref={profilRef}>
          <button
            type="button"
            className="profil"
            onClick={() => setMenuOpen((open) => !open)}
            aria-label="Menu profil"
          >
            <span className="avatar">
              <span className="avatar-initials">{initials}</span>
              <ImageProfil id={userData.id} />
            </span>
          </button>

          {menuOpen && (
            <div className="profil_menu">
              <div className="profil_menu-header">
                <span className="avatar avatar-lg">
                  <span className="avatar-initials">{initials}</span>
                  <ImageProfil id={userData.id} />
                </span>
                <div>
                  <p>
                    {userData.firstname} {userData.name}
                  </p>
                  {userData.service && <span>{userData.service}</span>}
                </div>
              </div>

              <ul onClick={() => setMenuOpen(false)}>
                <li>
                  <Link to={`/userprofil/${userData.id}`}>
                    <User size={15} /> Mon profil
                  </Link>
                </li>
                {userData.isAdmin && (
                  <li>
                    <Link to={`/dashboard`}>
                      <Shield size={15} /> Administration
                    </Link>
                  </li>
                )}
                <li className="separator" aria-hidden="true"></li>
                <Logout icon={<LogOut size={15} />} />
              </ul>
            </div>
          )}
        </div>
      </div>

      <SearchPalette open={paletteOpen} onClose={() => setPaletteOpen(false)} />
    </header>
  );
};

export default Nav;
